/**
 * When the curated list is sent, as the pages say it.
 *
 * WHY A SECOND COPY. The authority is `backend/campaign/landingSendWindow.js`;
 * this cannot import it, because `react-scripts`' ModuleScopePlugin refuses any
 * import from outside `src/`, so a relative import across that boundary breaks
 * the test runner and the CRA build. The repo's established answer to exactly
 * this is `landingTopics.test.js`: the backend owns the values and a test reads
 * THIS file and fails if the two disagree. `campaignSendWindow.test.js` does
 * that here.
 *
 * So: do not edit these without editing the backend module. The test will stop
 * you, which is the arrangement working rather than the arrangement failing.
 *
 * The defect this replaces: all three landing pages, three FAQ answers and the
 * confirmation screen said "8:00 CET" while the stored send timezone was
 * `Europe/London`, an hour behind. Every campaign email ever sent arrived an
 * hour after the time the visitor had been given.
 *
 * The label says CET again as of 26 October, but the defect has not returned:
 * this time the SCHEDULE moved with it, to `Europe/Berlin`, and the drift test
 * now checks that the two agree rather than banning the word.
 */

/** @see backend/campaign/landingSendWindow.js */
export const CAMPAIGN_SEND_WINDOW_LABEL = '8:00 AM CET';

/** @see backend/campaign/landingSendWindow.js */
export const CAMPAIGN_SEND_DAYS_LABEL = 'every weekday';

/** @see backend/campaign/landingSendWindow.js */
export const CAMPAIGN_SEND_WINDOW_SENTENCE = `${CAMPAIGN_SEND_DAYS_LABEL} at ${CAMPAIGN_SEND_WINDOW_LABEL}`;
